module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-legend-3dd51ae619c2a233c994b219a3e451a1.svg";